import Box from '@mui/material/Box';
import Skeleton from '@mui/material/Skeleton';

const ReviewerUsersSkeleton = ({}) => {
  return (
    <Box sx={{ display: 'flex', flexDirection: 'column', gap: '20px', padding: '2rem', overflowY: 'auto' }}>
      {Array.from(new Array(7)).map((_, index) => (
        <Box key={index} sx={{ display: 'flex', gap: '10px', alignItems: 'center' }}>
          <Skeleton animation='wave' width={16} height={23} />
          <Skeleton animation='wave' variant='circular' width={40} height={40} />
          <Box width={350}>
            <Skeleton animation='wave' height={20} width='80%' style={{ marginBottom: 6 }} />
            <Skeleton animation='wave' height={20} width='40%' />
          </Box>
        </Box>
      ))}
    </Box>
  );
};

export default ReviewerUsersSkeleton;
